/* Architect — in-app port of the standalone poster SPA. Default export,
   no required props. Gated on architect:use; the main app owns auth,
   the users panel and the workspace chrome, so this is only Projects +
   Editor wrapped in a light-themed .architect-scope card. */

import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import ClientWorkspace from './ClientWorkspace';
import EditorView from './EditorView';
import { ToastHost } from './toast';
import { MODELS } from './utils';
import { takeLaunchProject } from './launch';
import './architect.css';

type View = { name: 'projects' } | { name: 'editor'; projectId: string };

export default function ArchitectPanel() {
  const { hasPermission } = useAuth();
  // DESIGN47 — a deep link (?project=…) opens that project's editor at once.
  const [view, setView] = useState<View>(() => {
    const project = takeLaunchProject();
    return project ? { name: 'editor', projectId: project } : { name: 'projects' };
  });
  // Sticky across project switches (EditorView remounts per project).
  const [model, setModel] = useState(MODELS[0].value);

  if (!hasPermission('architect:use')) {
    return (
      <div className="architect-scope">
        <div className="arch-notice">
          <h3>Architect</h3>
          <p>
            This account has no access to Architect. Ask an administrator to
            grant Architect access.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="architect-scope">
      {view.name === 'projects' ? (
        <ClientWorkspace
          onOpen={(id) => setView({ name: 'editor', projectId: id })}
        />
      ) : (
        <EditorView
          key={view.projectId}
          projectId={view.projectId}
          onBack={() => setView({ name: 'projects' })}
          model={model}
          setModel={setModel}
        />
      )}
      <ToastHost />
    </div>
  );
}
